import {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  EffectFade,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
export default function ImageSwiper(props) {
  return (
    <>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, Autoplay, EffectFade]}
        // spaceBetween={10}
        slidesPerView={1}
        // autoHeight={true}
        autoplay={{
          delay: 7000,
          disableOnInteraction: false,
          waitForTransition: false,
        }}
        // loop={true}
        // navigation
        pagination={{
          clickable: true,
          type: "bullets",
          // dynamicBullets: true,
        }}
        effect="fade"
        // speed={1500}
        direction="vertical"
        autoHeight={true}
        longSwipesRatio={0.05}
        // maxHeight="100%"
      >
        {props.images.length > 0 &&
          props.images.map((src, index) => (
            <SwiperSlide
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              key={index}
            >
              {["jpg", "jpeg", "png", "gif", "webp"].includes(
                src?.split(".").pop()?.split("?")[0]?.toLowerCase(),
              ) ? (
                <img
                  className="swiperimg"
                  src={src}
                  alt={`Slide ${index + 1}`}
                />
              ) : (
                <video
                  className="swiperimg"
                  src={src}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              )}
            </SwiperSlide>
          ))}
      </Swiper>
    </>
  );
}
